import { Claim } from "types";

export const computeClaimFormattedId = (rental: Pick<Claim, "id">) =>
  "#" + rental.id.split("-")[0].toUpperCase();
